import { cn } from "@/lib/utils";

const LEVEL_STYLES = {
  ok: { dot: "bg-success", label: "In place", chip: "bg-success-soft text-success border-success/30" },
  low: { dot: "bg-info", label: "Low", chip: "bg-info-soft text-info border-info/30" },
  medium: { dot: "bg-warning", label: "Medium", chip: "bg-warning-soft text-warning border-warning/30" },
  high: { dot: "bg-destructive", label: "High", chip: "bg-destructive-soft text-destructive border-destructive/30" },
  unknown: { dot: "bg-muted-foreground", label: "Unanswered", chip: "bg-secondary text-muted-foreground border-border" },
  na: { dot: "bg-border", label: "N/A", chip: "bg-secondary text-muted-foreground border-border" }
};

export function ResultsRows({ title, eyebrow, rows, emptyLabel = "No items recorded." }) {
  return (
    <section className="paper-card overflow-hidden">
      <div className="flex items-center justify-between border-b border-border bg-card/80 px-6 py-4">
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h3 className="font-display text-lg font-medium text-foreground">{title}</h3>
        </div>
        <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          {rows.length} item{rows.length === 1 ? "" : "s"}
        </span>
      </div>
      {rows.length === 0 ? (
        <div className="px-6 py-8 text-sm text-muted-foreground">{emptyLabel}</div>
      ) : (
        <ul className="divide-y divide-border">
          {rows.map((row) => {
            const style = LEVEL_STYLES[row.level] || LEVEL_STYLES.unknown;
            return (
              <li key={row.id} className="grid grid-cols-1 gap-3 px-6 py-5 md:grid-cols-12 md:items-start md:gap-6">
                <div className="md:col-span-4">
                  <div className="flex items-center gap-2">
                    <span className={cn("h-2 w-2 shrink-0 rounded-full", style.dot)} />
                    <p className="font-display text-base font-medium text-foreground">{row.topic}</p>
                  </div>
                  <span
                    className={cn(
                      "mt-2 inline-flex rounded-sm border px-2 py-0.5 font-mono-label text-[10px] uppercase tracking-[0.18em]",
                      style.chip
                    )}
                  >
                    {style.label}
                  </span>
                </div>
                <div className="md:col-span-8">
                  <p className="text-sm leading-relaxed text-foreground">{row.label}</p>
                  <p className="mt-1 text-xs leading-relaxed text-muted-foreground">{row.prompt}</p>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}
